import cn from "classnames";
import React from "react";
import { StyledElementWrapper } from "./StyledElementWrapper";

import { SwarovskiOptikFormInputElementParams } from "./types";
import { InputPlaceholder2, textFieldPlaceholderStyles2 } from "./InputPlaceholder";
import { InputInput } from "./InputInput";
import { css } from "@emotion/react";
import { errorMessageStyles } from "./errorMessageStyles";
import { SmallLoadingSpinner } from "../../../../../../routes/modal-loading-spinner";
import { TickSvg } from "../../../../../../assets";
import { CSS_COLORS } from "../../../../../../styles/styles-css-variables";

export function SwarovskiOptikFormInputElement(props_: SwarovskiOptikFormInputElementParams) {
  const { variant: variant_, stateIcon, ...props } = props_;
  const variant = variant_ ?? "white";

  return (
    <StyledElementWrapper
      className={cn(`u-relative variant-${variant}`, {
        disabled: props.element.disabled,
        "placeholder-visible": props.value,
        "has-error": !!props.errorMessage,
        "with-right-padding": !!stateIcon,
      })}
    >
      {typeof props.element.placeholder !== "undefined" && (
        <InputPlaceholder2
          placeholder={props.element.placeholder}
          required={!!props.element.required}
          attachStyles={css`
            position: absolute;
            left: 12px;

            // border
            top: 1px;
            height: calc(100% - 2px);
          `}
        />
      )}

      {typeof props.errorMessage === "string" && <span css={errorMessageStyles}>{props.errorMessage}</span>}

      <InputInput {...props} errorMessage={props.errorMessage} />

      <div
        css={css`
          position: absolute;
          top: 0;
          right: 8px;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;

          color: ${CSS_COLORS.White};
        `}
      >
        {stateIcon === "syncing" ? (
          <SmallLoadingSpinner color={"white"} noMargin={true} />
        ) : stateIcon === "synced" ? (
          <TickSvg />
        ) : null}
      </div>
    </StyledElementWrapper>
  );
}
